class productSwitcher extends HTMLElement {
    constructor() {
        super()
        this.addEventListener('click', this.handleClick)
    }

    handleClick() {
     
        this.image  = this.dataset.dropProductImage
        this.handle = this.dataset.productHandle

        document.querySelectorAll('product-switcher').forEach(elm => {
            elm.classList.remove('active');
        })

        this.classList.add('active');

        // render new contents
        this.updateHistoryState(this.handle)
        this.renderSections(this.handle)
    }

    getSectionsToRender() {
        return [
            {
                selector: "js-main-product",
                sectionId: document.querySelector("[js-main-product]")?.dataset.section
            },
            {
                selector: "js-media-gallery-section",
                sectionId: document.querySelector("[js-media-gallery-section]")?.dataset.section
            }
        ]
    }

    renderSections(handle) {
        this.getSectionsToRender().forEach(section=> {
            
            document.querySelector(`[${section.selector}]`).classList.add("loading")
           if(section.sectionId != undefined) {
              fetch(`/products/${handle}?section_id=${section.sectionId}`)
              .then(response=>response.text())
              .then(html=>{
  
                  const doc = new DOMParser().parseFromString(html, "text/html");
                  const elementToReplace = document.querySelector(`[${section.selector}]`);
                
                  if(elementToReplace && doc.querySelector(`[${section.selector}]`)) {
                      elementToReplace.innerHTML ='';
                      elementToReplace.innerHTML = doc.querySelector(`[${section.selector}]`).innerHTML
                  }

                  switch (section.selector) {
                    case "js-main-product":
                        document.dispatchEvent(new CustomEvent('complementarySlider:init'))
                        document.dispatchEvent(new CustomEvent('productPageScript:init'))
                        document.querySelector(`[${section.selector}]`).classList.remove("loading")
                    break;
                    case "js-media-gallery-section":
                        document.dispatchEvent(new CustomEvent('imageGallerySlider:init'))
                      break;
                  }
                 
              }).catch(function(error) {
                  console.log(error)
              })
           }
        }
        )
    }

    updateHistoryState(handle) {
        var newurl = `${window.location.protocol}//${window.location.host}/products/${handle}`;
        window.history.pushState({
            path: newurl
        }, "", newurl)
    }
}

customElements.define('product-switcher', productSwitcher)

